import React, {FC} from 'react';
import './ServiceBanner.scss';
import Logo from '../../assets/icons/Vector_gold_v2.svg';

type Props = {
    title: string
};

const ServiceBanner:FC<Props> = ({title}) => {
    return (
        <section className='service-banner-section section-common'>
            <div className="wrapper">
            
            <div className="service-banner-img" data-aos="fade-up" data-aos-duration="1000">
                                   <img src={Logo} alt="zlota centrum zdrowia logo" />
                </div>
                <div className="container">
                <div className="banner-geometric-overlay-square-2"/>
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <div className="service-banner-text"  data-aos="fade-up" data-aos-duration="1000">
                                    <h2>{title}</h2>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceBanner;